import React from 'react';
import { translate } from 'react-switch-lang';
import StandardButton from './Base/StandardButton';
import authStorage from '../../storages/mobx/authStorage';

function PasswordResetButton({ t, id }) {
  return (
    <StandardButton onClick={() => authStorage.resetPassword(id)} id="password-resetButton">{t('auth.Restore')}</StandardButton>
  );
}

PasswordResetButton.propTypes = {};

export default translate(PasswordResetButton);
